export enum QueryKey {
  PlantRunningTimes = 'plant-running-times',
  PlantsRunningTimes = 'plants-running-times'
}
